<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="play-circle-outline" *ngIf="action === 'activate'"></nb-icon>
        <nb-icon icon="stop-circle-outline" *ngIf="action === 'deactivate'"></nb-icon>
        <div class="ml-2" *ngIf="action === 'activate'" i18n>Activating Campaign: {{ campaign.id }}</div>
        <div class="ml-2" *ngIf="action === 'deactivate'" i18n>Deactivating Campaign: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div *ngIf="!disableDatepicker">
      <div class="row">
        <div class="col"><label i18n>Start Time:</label></div>
        <div class="col-9">
          <div class="picker-row">
            <input
              id="start"
              nbInput
              [(ngModel)]="startDateForDatepicker"
              required
              [owlDateTime]="startPicker"
              [min]="minStartDate"
              [owlDateTimeTrigger]="startPicker"
              (ngModelChange)="changeEvent()"
              placeholder="Select Start Time"
              i18n-placeholder
            />
            <owl-date-time #startPicker></owl-date-time>
          </div>
        </div>
      </div>
      <br />
      <div class="row" *ngIf="!disableDatepicker">
        <div class="col"><label i18n>End Time:</label></div>
        <div class="col-9">
          <div class="picker-row">
            <input
              id="end"
              nbInput
              [(ngModel)]="endDateForDatepicker"
              required
              [owlDateTime]="endPicker"
              [min]="minEndDate"
              [owlDateTimeTrigger]="endPicker"
              (ngModelChange)="changeEvent()"
              placeholder="Select End Time"
              i18n-placeholder
            />
            <owl-date-time #endPicker></owl-date-time>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col"><label i18n>Schedule:</label></div>
        <div class="col-9">
          <nb-select
            id="schedule_seconds"
            name="schedule_seconds"
            class="custom small"
            placeholder="Select Schedule"
            i18n-placeholder
            [(ngModel)]="campaign.schedule_seconds"
            style="width: 100%"
            [disabled]="disableDatepicker"
          >
            <nb-option *ngFor="let frequency of FREQUENCIES" [value]="frequency.value"
              >{{ frequency.label }}
            </nb-option>
          </nb-select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col" i18n>Are you sure you want to activate this campaign?</div>
      </div>
    </div>

    <div class="row" *ngIf="disableDatepicker">
      <div class="col" i18n>Are you sure you want to deactivate this campaign?</div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>No</button>
      <button
        *ngIf="action === 'activate'"
        nbButton
        class="ml-3"
        status="success"
        (click)="clickedStart()"
        nbTooltip="Clicking Yes will start the Campaign as per the schedule."
        i18n-nbTooltip
        i18n
      >
        Yes
      </button>
      <button
        *ngIf="action === 'deactivate'"
        nbButton
        class="ml-3"
        status="danger"
        (click)="clickedStop()"
        nbTooltip="Clicking Yes will deactivate the Campaign and Insight immediately."
        i18n-nbTooltip
        i18n
      >
        Yes
      </button>
    </div>
  </nb-card-footer>
</nb-card>
